<template>
    <section
        :id="id"
        class="compete-header"
        :class="basicClassName"
        v-bind="$attrs"
    >
        <a-breadcrumbs v-if="breadcrumbs" :links="breadcrumbs" :sublinks="true" />
        <div class="a-container">
            <div class="wrapper">
                <div class="content">
                    <a-dangerous-html tag="h1" class="title" :content="title" />
                    <a-dangerous-html tag="p" class="lead" :content="lead" />
                    <a-dangerous-html tag="p" class="body-text" :content="bodyText" />
                    <a-button v-bind="button" />
                    <h2 v-if="cardsTitle" class="cards-title">
                        {{ cardsTitle }}
                    </h2>
                    <div class="cards">
                        <div v-for="card in cards" :key="card.title" class="card">
                            <div class="card-title">
                                {{ card.title }}
                            </div>
                            <p>
                                {{ card.text }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ABreadcrumbs from '@core/components/breadcrumbs/breadcrumbs.vue';
import AButton from '@core/components/button/button.vue';
import ADangerousHtml from '@core/components/dangerous-html/dangerous-html.vue';
import contentMixin from '@core/mixins/content.js';
import styleMixin from '@core/mixins/style.js';

export default {
    components: {
        AButton,
        ADangerousHtml,
        ABreadcrumbs,
    },
    mixins: [contentMixin, styleMixin],
    props: {
        breadcrumbs: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default: '',
        },
        lead: {
            type: String,
            default: '',
        },
        bodyText: {
            type: String,
            default: '',
        },
        button: {
            type: Object,
            default() {},
        },
        cardsTitle: {
            type: String,
            default: '',
        },
        cards: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style lang="postcss" scoped>
.compete-header {
    padding-top: 104px;
    color: var(--av-nav-primary);

    &.s-slice_background {
        @mixin background;
    }
}

.wrapper {
    padding-bottom: 64px;
    border-bottom: 1px solid var(--av-brand-secondary-light);
}

.a-breadcrumbs {
    position: relative;
    margin-bottom: 48px;
}

.title {
    @mixin large;
    font-weight: 500;

    @media (--viewport-tablet) {
        font-size: 64px;
        line-height: 72px;
    }

    @media (--viewport-desktop) {
        font-size: 72px;
        line-height: 80px;
    }

    &:deep(b) {
        font-weight: 800;
    }
}

.lead {
    @mixin display-accent;
    margin-top: 16px;

    @media (--viewport-tablet) {
        @mixin hero-accent;
    }

    @media (--viewport-desktop) {
        @mixin large-accent;
    }
}

.body-text {
    @mixin lead;
    margin-top: 24px;

    @media (--viewport-tablet) {
        @mixin title;
    }
}

.a-button {
    margin-top: 24px;
}

.cards-title {
    @mixin display-accent;
    margin-top: 64px;
    margin-bottom: 40px;

    @media (--viewport-tablet) {
        @mixin hero-accent;
    }
}

.cards {
    display: flex;
    gap: 16px;
    flex-direction: column;

    @media (--viewport-desktop) {
        flex-direction: row;
    }
}

.card {
    @mixin lead;
    padding: 24px;
    border-radius: 24px;
    background: var(--av-solid-brand-accent);
}

.card-title {
    @mixin title-accent;
    margin-bottom: 8px;

    @media (--viewport-tablet) {
        @mixin display-strong;
    }
}

</style>
